// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2bd6be3f","455":"0c0010b3","977":"df43af07"}[chunkId] + ".chunk.js";
};